import init from './thing'

const connection =
{
    ...init
};

export default connection ;
